import React from 'react';
import './App.css';

import Dashboard from './pages/dashboard'
import Estadisticas from 'pages/dashboard/Estadisticas';

// PERMISOS
// import Vehiculo from 'pages/permisos/Vehiculo.js'
import Vehiculos from 'pages/permisos/Vehiculos.js'
import Predios from 'pages/obras/Predios.js'
import Certificados from 'pages/obras/Certificados.js'
import AdministracionVehiculo from 'pages/permisos/AdministracionVehiculo.js'
// import PermisosEnLista from 'pages/permisos/PermisosEnLista.js'
import Administracion from 'pages/administracion/Administracion'
import EstadoServicios from 'pages/permisos/EstadoServicios'

import Listas from 'pages/factibilizaciones/Listas.js'
import Lista from 'pages/factibilizaciones/Lista.js'

// USER AUTH
import Login from './auth/Login'
import PasswordRecovery from './auth/PasswordRecovery'
import PrivateRoute from './auth/PrivateRoute'

import ErrorHandler from './layout/ErrorHandler.js';

import PermisoPublico from 'pages/permisos/PermisoPublico.js'

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Typography } from '@mui/material'; // Añadido para el mensaje de mantenimiento

import { Switch, Route, BrowserRouter } from 'react-router-dom'
import Logo from './layout/logo.png';
import {
  Box,

} from '@mui/material';

////////////////////////////////
// INTERRUPTOR DE MANTENIMIENTO
///////////////////////////////
// Se debe cambiar esto a 'false' cuando se termine la actualización
const MANTENIMIENTO_ACTIVO = false;
///////////////////////////////

const theme = createTheme({
  overrides: {
    MuiPaper: {
      root: {

      },
      elevation1: {
        boxShadow: '0px 0px 15px 5px rgba(125,125,125,0.1)'
      }
    },
    MuiTypography: {
      h6: {
        color: '#5e56c4',
        fontWeight: 300
      },
      h5: {
        color: '#5e56c4',
        fontWeight: 300
      }
    },
    MuiTableHead: {
      root: {
        backgroundColor: '#f1faf9',
      }
    },
    MuiButton: {
      containedPrimary: {
        boxShadow: '0px 0px 15px 3px rgba(94,86,196,0.4)',
        '&:hover': {
          boxShadow: '0px 0px 15px 3px rgba(94,86,196,0.6)',
        }
      }
    }
    ,
    MuiTableCell: {
      head: {
        fontWeight: 600,

      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: '46px',
        // color: '#FFFFFF',
      }
    }

  },

});


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null
    };
  }
  componentDidMount() {
    document.title = 'Portal Municipal';
  }

  render() {
    // PANTALLA DE MANTENIMIENTO PCV

    if (MANTENIMIENTO_ACTIVO) {
      return (
        <ThemeProvider theme={theme}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f1faf9',
            textAlign: 'center',
            padding: '20px'
          }}>
            <Box p={10} >
              <Box>
                <img src={Logo} alt='Logo' />
              </Box>
            </Box>
            <Typography variant="h4" style={{ fontWeight: 600, color: '#5e56c4', marginBottom: '20px' }}>
              Plataforma en Mantenimiento
            </Typography>
            <Typography variant="h6" paragraph>
              El sistema de Permisos de Circulación se encuentra temporalmente en mantenimiento programado.
            </Typography>
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              Hora estimada de término de la intervención: [11:00 p.m.]
            </Typography>
            <Typography variant="body1" style={{ marginTop: '30px', color: '#666' }}>
              Agradecemos su comprensión.
            </Typography>
          </div>
        </ThemeProvider>
      );
    }

    return (
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <ErrorHandler>
            <Switch>

              {/* USER */}
              <Route exact path='/login'>
                <Login />
              </Route>

              <Route exact path='/password_recovery'>
                <PasswordRecovery />
              </Route>
              <Route exact path='/password_recovery/:token'>
                <PasswordRecovery />
              </Route>

              <PrivateRoute exact path='/dashboard/'>
                <Dashboard />
              </PrivateRoute>

              <PrivateRoute exact path='/permisos/estadisticas/'>
                <Estadisticas />
              </PrivateRoute>

              {/* ADMIN */}
              <PrivateRoute exact path='/permisos/vehiculo/'>
                <Vehiculos />
              </PrivateRoute>

              <PrivateRoute exact path='/permisos/administracion_vehiculo/:vehiculo_uuid/:lista_uuid?'>
                <AdministracionVehiculo />
              </PrivateRoute>

              <PrivateRoute exact path='/permisos/lista/'>
                <Listas />
              </PrivateRoute>
              <PrivateRoute exact path='/permisos/lista/:lista_uuid'>
                <Lista />
              </PrivateRoute>

              {/* SUPER ADMIN */}
              <PrivateRoute exact path='/permisos/administracion/'>
                <Administracion />
              </PrivateRoute>
              <PrivateRoute exact path='/permisos/estado_servicios/'>
                <EstadoServicios />
              </PrivateRoute>

              {/* OBRAS */}
              <PrivateRoute exact path='/obras/predios/'>
                <Predios />
              </PrivateRoute>
              <PrivateRoute exact path='/obras/certificados/'>
                <Certificados />
              </PrivateRoute>

              {/* DASHBOARD */}
              <Route exact path='/'>
                <PermisoPublico />
              </Route>
              <Route exact path='/:permiso_uuid'>
                <PermisoPublico />
              </Route>

              <Route exact path='*'>
                <PermisoPublico />
              </Route>

            </Switch>
          </ErrorHandler>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}

export default App;